if (!customElements.get('fc-tiktok-videos')) {
  customElements.define(
    'fc-tiktok-videos',
    class FcTiktokVideos extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.slider = this.querySelector('.swiper');
        if (!this.slider) return;

        this.slideCount = this.querySelectorAll('.fc-tiktok-videos__slide').length;
        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        this.initSlider();

        this.slider.addEventListener('click', (e) => {
          const muteBtn = e.target.closest('.fc-tiktok-videos__mute');
          if (muteBtn) {
            e.stopPropagation();
            this.toggleMute(muteBtn);
            return;
          }
          const slide = e.target.closest('.swiper-slide');
          if (!slide) return;
          this.handleSlideClick(slide);
        });

        this.mediaQuery = window.matchMedia('(max-width: 767px)');
        this.mediaQuery.addEventListener('change', (e) => {
          this.isMobile = e.matches;
          this.destroySlider();
          this.initSlider();
        });
      }

      initSlider() {
        const options = {
          slidesPerView: 'auto',
          spaceBetween: 8,
          grabCursor: true,
          loop: this.slideCount > 2,
        };

        if (this.isMobile) {
          options.centeredSlides = true;
          options.initialSlide = 1;
        } else {
          options.centeredSlides = false;
          options.initialSlide = 0;
        }

        this.swiperInstance = new window.FoxTheme.Carousel(this.slider, options);
        this.swiperInstance.init();

        this.swiper = this.swiperInstance.slider || this.swiperInstance;

        this.playActiveVideo();

        this.swiper.on('slideChange', () => {
          this.playActiveVideo();
        });
      }

      destroySlider() {
        this.pauseAllVideos();
        if (this.swiper && this.swiper.destroy) {
          this.swiper.destroy(true, true);
        }
        this.swiper = null;
        this.swiperInstance = null;
      }

      handleSlideClick(slide) {
        const slides = Array.from(this.swiper.slides);
        const clickedIndex = slides.indexOf(slide);
        if (clickedIndex === -1) return;

        if (this.isMobile) {
          this.swiper.slideTo(clickedIndex);
        } else {
          if (this.slideCount <= 2) {
            this.swiper.slideTo(clickedIndex);
          } else {
            this.swiper.slideTo(clickedIndex - 1);
          }
        }
      }

      playActiveVideo() {
        this.pauseAllVideos();

        if (this.isMobile) {
          this.playSlideAtIndex(this.swiper.activeIndex);
        } else {
          if (this.slideCount <= 2) {
            this.playSlideAtIndex(this.swiper.activeIndex);
          } else {
            this.playSlideAtIndex(this.swiper.activeIndex + 1);
          }
        }
      }

      toggleMute(btn) {
        const slide = btn.closest('.fc-tiktok-videos__slide');
        const video = slide.querySelector('.fc-tiktok-videos__video');
        if (!video) return;

        video.muted = !video.muted;
        slide.classList.toggle('fc-tiktok-videos__slide--unmuted', !video.muted);
        btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }

      pauseAllVideos() {
        this.querySelectorAll('.fc-tiktok-videos__slide').forEach((slide) => {
          slide.classList.remove('fc-tiktok-videos__slide--active', 'fc-tiktok-videos__slide--unmuted');
          const video = slide.querySelector('.fc-tiktok-videos__video');
          video.pause();
          video.muted = true;
          video.currentTime = 0;
          const muteBtn = slide.querySelector('.fc-tiktok-videos__mute');
          if (muteBtn) muteBtn.setAttribute('aria-label', 'Unmute video');
        });
      }

      playSlideAtIndex(index) {
        const slides = this.swiper.slides;
        if (!slides || !slides[index]) return;

        const slide = slides[index];
        slide.classList.add('fc-tiktok-videos__slide--active');
        const video = slide.querySelector('.fc-tiktok-videos__video');
        if (video) video.play();
      }
    }
  );
}
